<div
cdkTrapFocus
[cdkTrapFocusAutoCapture]="true"
aria-modal="true"
role="dialog"
aria-labelledby="modal-title"
aria-describedby="modal-description"
id="tab-modal"
>
<!-- <div class="topaz-dialog-header">
  <h1 topazTitle="3" id="modal-title">Lorem Ipsum</h1>
</div> -->

<mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center" id="tab-group">
  <mat-tab label="{{ 'Your Privacy' }}" id="tab-one">
    <mat-dialog-content role="document" class="tab-dialog-modal-content">
    <h2>
      Your Privacy
    </h2>
    <div>
        <p>When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device, and is mostly used to make the site work as you expect it to. 
        The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. 
        Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.
        <a href="#">More information</a></p>
    </div>
    <form [formGroup]="dialogForm" role="form">
        <!-- <div class="dialog-form-field-container">
          <mat-form-field>
            <mat-label>Input one</mat-label>
            <input
              type="text"
              matInput
              formControlName="name"
              id="first-focus"
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Input two</mat-label>
            <input type="text" matInput formControlName="address1" />
          </mat-form-field>
        </div> -->
        <div [align]="'end'" class="tab-dialog-modal-content">
            <!-- <button
            mat-button
            mat-dialog-close="cancel"
            (click)="this.dialogRef.close()"
            id="cancel-btn"
          >
            Cancel
          </button> -->
          <button mat-button  aria-label="primary" class="topaz-button-small mdc-button mat-mdc-button mat-unthemed mat-mdc-button-base"
          id="submit-btn"  mat-dialog-close="cancel"  (click)="this.dialogRef.close()">Cancel</button>
          <!-- <button
            mat-flat-button
            mat-dialog-close="yes"
            color="primary"
            id="submit-btn"
          >
            I understand
          </button> -->&nbsp;&nbsp;&nbsp;&nbsp;
          <button mat-flat-button aria-label="primary"  color="primary" class="topaz-button-small mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base"
          id="submit-btn"  mat-dialog-close="yes" (click)="submitPrivacyForm()">I understand</button>
        </div>
    </form>
    </mat-dialog-content>
  </mat-tab>
  <mat-tab label="{{ 'Strictly Necessary Cookies'}}" id="tab-two">
    <mat-dialog-content role="document" class="form-dialog-modal-content">
    <h2>
      Strictly Necessary Cookies
    </h2>
    <p>
        These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. 
You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.
    </p>
    <form [formGroup]="dialogForm" role="form">
        <!-- <mat-form-field>
          <mat-label>Name</mat-label>
          <input type="text" matInput formControlName="name" />
          <mat-error>Please enter a name</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Address 1</mat-label>
          <input type="text" matInput formControlName="address1" />
          <mat-error>Please enter an address</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Address 2</mat-label>
          <input type="text" matInput formControlName="address2" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Birthdate</mat-label>
          <input
            type="text"
            matInput
            [matDatepicker]="birthdayPicker"
            formControlName="birthdate"
          />
          <mat-datepicker-toggle matIconSuffix [for]="birthdayPicker">
            <fa-icon [icon]="icons.faCalendar"></fa-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #birthdayPicker></mat-datepicker>
        </mat-form-field> -->
        <div matDialogActions [align]="'end'" class="tab-dialog-modal-content">
            <button mat-button  aria-label="primary" class="topaz-button-small mdc-button mat-mdc-button mat-unthemed mat-mdc-button-base"
            id="submit-btn"  mat-dialog-close="cancel"  (click)="this.dialogRef.close()">Cancel</button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <button mat-flat-button aria-label="primary" class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base"
            id="submit-btn"  mat-dialog-close="yes" (click)="submitForm()">I understand</button>
          
        </div>
    </form>
    </mat-dialog-content>
  </mat-tab>
</mat-tab-group>
</div>
  